import styled, { keyframes } from 'styled-components';

// ------- Styled Components -------

export const ModalPanel = styled.div`
  background-color: rgb(0 0 0 / 95%);
  backdrop-filter: blur(3px) grayscale(1);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow-y: scroll;
  overflow-y: auto;
  padding: 1em;
`

export const show = keyframes`
  from {
    transform: scale(0.9) translateY(-50px);
  }
  to {
    transform: scale(1);
  }
`

export const Content = styled.div`
  transform: scale(0.9) translateY(-50px);
  width: 100%;
  width: 550px;
  display: flex;
  flex-direction: column;
  background-color: #000000;
  background-color: #0D0D0D;
  border: 1px solid #414244;
  min-height: 180px;
  will-change: transform;
  animation: 350ms ease ${show} forwards;
  border-radius: 0.5em;
  overflow: hidden;
  margin-top: 3em;
`

export const Bar = styled.div`
  font-size: 1.1em;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.3em;
  position: relative;
  font-weight: bold;
  font-family: 'Chivo';
  font-style: italic;
  background: ${props => {
    switch (props.type) {
      case 'error': return 'linear-gradient(rgb(181 41 41 / 80%),#b13d3d)'
      default: return 'linear-gradient(rgba(42, 42, 42, 0.8),#000000)'
    }
  }};
`

export const CloseButton = styled.button`
  border: 0;
  outline: 0;
  background: transparent;
  font-size: 1.3em;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.5em;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);

  &:hover {
    opacity: 0.7;
  }
`

export const ButtonsDelete = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 500px;
  margin: auto;
  gap: 2em;
`

export const ButtonBase = styled.button`
  border: 0;
  outline: 0;
  color: #FFF;
  font-size: 1.2em;
  font-weight: bold;
  padding: 0.5em 2.5em;
  border-radius: 1em;
  transition: transform 200ms ease;
  will-change: transform;
  width: 80px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.9;
    transform: scale(1.02);
  }
`

export const ButtonCancel = styled(ButtonBase)`
  background-color: #88ba44;
`

export const ButtonConfirm = styled(ButtonBase)`
  background-color: #ff0000;
`
